import { render, staticRenderFns } from "./sma-button.vue?vue&type=template&id=f2dd984e&"
import script from "./sma-button.vue?vue&type=script&lang=js&"
export * from "./sma-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports